import React from "react";
import Style from "./index.module.css";

const FormLabel = ({ label }) => {
  return <p className={Style.FormLabel}>{label}</p>;
};

export default FormLabel;
